import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar27Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar27 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar27Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar27">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="Vector"
          d="M235.44 264.918c-14.569-8.365-45.35-20.344-94.33-20.725-44.707-.349-71.858 10.001-88.357 22.687 26.596 22.917 61.214 36.779 99.073 36.779 34.403 0 66.13-11.447 91.589-30.734-2.097-3.344-4.719-6.132-7.983-8.007h.008Z"
          fill="#000"
        />
        <G id="Group">
          <Path
            id="skin"
            d="M223.548 164.145c2.073-11.645-.937-13.909-.937-28.906 1.771-40.656-16.435-78.094-41.926-78.094-70.372 0-77.418 19.399-77.418 64.828 0 2.367-.39 1.485-.183 3.932-6.673 0-9.469 15.681-6.546 24.784 6.848 21.328 21.758 18.85 22.084 18.667 2.661 6.284-5.497 48.234-6.514 55.581-2.677 19.399-18.906 23.688-18.906 23.688s65.201 46.367 84.551 35.286c15.347-8.786 13.735-27.914 8.135-30.957-4.242-2.303-4.314-1.676-10.613-4.273-3.066-1.66-.135-20.812.564-33.26 9.501-1.438 18.779 10.168 28.486-10.168 3.916-8.197 16.673-26.785 19.223-41.108Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            opacity={0.75}
            d="M133.977 193.258c0 .358 2.113 17.373 22.424 32.696 8.579 6.474 11.701 7.531 17.937 9.405.032-5.679 1.668-20.01 1.668-20.01-.334.04-25.396-8.777-42.029-22.083v-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_3"
            opacity={0.75}
            d="M187.826 167.903c-.501 2.319 1.922 3.86 10.239 3.471 6.855-.326 9.064-4.727 7.713-5.338-1.342-.62-3.146 2.145-7.61 2.145-6.506 0-9.842-2.598-10.35-.27l.008-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M173.138 181.716c.667.795 11.367 13.759 22.171 13.759 9.206 0 11.002-10.248 11.24-10.812-2.892 1.24-5.275 4.751-10.653 4.751-11.581 0-19.493-5.251-22.758-7.698Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M199.852 179.873c-2.828 0-3.733 1.398-3.733 1.398s-3.599-1.708-6.601-1.708c-3.003 0-5.744 1.549-8.572 1.939-2.859.389-7.8-.088-7.8-.088s-.024.278 0 .31c3.265 2.034 10.97 3.559 22.544 3.559 5.385 0 7.975-.072 10.866-1.104l.016-.032s-3.892-4.266-6.72-4.266v-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_6"
            d="M144.335 123.26c-.104.071-.048.238.079.222 2.264-.302 13.695-1.509 21.765-1.35 10.812.214 17.667 8.531 20.535 3.638 1.374-2.344.119-6.879-19.613-9.024-8.675-.945-15.069 1.04-22.774 6.514h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M182.615 144.715c-2.264-4.631-5.497-7.832-9.151-10.048-2.232-1.359-4.615-2.336-7.014-3.051-7.555-2.24-15.339-1.811-19.311-1.739-1.263.024-1.978 1.334-1.255 2.288l2.025 2.676c.318.421.85.66 1.407.62 1.827-.119 6.06-.167 11.009.024a5.57 5.57 0 0 0-.556 2.391c0 3.487 3.305 6.315 7.38 6.315 3.606 0 6.593-2.216 7.236-5.147 3.408 2.049 6.451 4.559 7.714 5.989.23.262.675-.008.524-.318h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M202.021 127.303c.858 1.271 3.297 3.424 5.251 1.986 2.891-3.003 7.149-5.37 13.901-5.553a202.177 202.177 0 0 0-.222-4.384c-16.046.143-20.098 6.219-18.922 7.951h-.008Z"
            fill="#000"
          />
          <Path
            id="hair"
            d="M243.097 206.508c0-12.606 20.336-27.715-6.561-106.523-26.889-78.808-90.557-60.252-100.073-51.268-8.444-3.622-34.158.183-52.46 33.022-18.31 32.838-43.808 69.355-24.339 96.093.12-7.403 1.374-10.533 3.781-15.951-1.946 9.135-2.24 12.646-.333 19.399 7.848 5.814 33.037 19.04 52.562 23.139 3.567-13.075 3.742-34.967 3.742-34.967s-22.95-4.346-23.29-21.837c-.342-17.492 1.302-20.241 6.966-21.726 5.664-1.485 20.335 18.509 20.335 18.509s3.4-11.916 5.918-16.825c4.139-8.079 4.941-2.192 17.293-17.293 12.353-15.093 14.926-29.709 26.675-31.592 0 0-5.513-9.564-10.39-13.607.619.294 1.128.516 1.485.62 4.226 1.239 11.431 12.415 11.431 12.415 9.945-3.63 20.518 3.917 20.733 11.987.214 8.07 7.641 18.263 15.291 25.062 7.642 6.792 11.947 29.963 10.049 48.559-15.648 33.945-16.96 51.697-31.56 51.848-6.307.063-13.687-.54-14.346-.207-.072.04-1.017 11.074-1.017 11.074s20.884 5.648 28.223 5.648c7.34 0 12.234-2.447 12.234-2.447s1.509 1.692-.374 5.648c-1.882 3.948-3.01 3.574-8.277 9.596 2.256-.191 8.984-3.345 18.246-6.149 9.779-2.963 8.492.961 15.832-.167-5.457-6.958-2.471-20.589-2.471-20.589s3.948 15.807 9.596 16.935c-5.648-6.021-4.893-15.807-4.893-28.414l-.008.008Z"
            fill={c.hair}
          />
          <Path
            id="Vector_9"
            d="M204.126 139.48a22.786 22.786 0 0 0-2.129 3.75c-.119.27.238.508.429.278.508-.628 1.366-1.486 2.439-2.407 1.167 1.787 3.328 3.01 5.83 3.01 3.742 0 6.768-2.685 6.768-5.997 0-1.057-.334-2.026-.874-2.884 3.448.342 5.14 1.724 7.292 1.7.016-1.62.024-3.241.016-4.869-3.407.199-7.332-1.207-11.033.405-3.257 1.422-6.339 3.622-8.746 7.03l.008-.016Z"
            fill="#000"
          />
        </G>
      </G>
    </Svg>
  );
};
